export default {
  accountStatusMap: (state, getters, rootState) => {
    return {
      1: 'active',
      2: 'verifying',
      3: 'passed',
      4: 'failed',
    }
  },
  accountStageMap: (state, getters, rootState) => {
    return {
      4: 'liveTrading',
      5: 'liveTradingPlus',
      2: 'evaluation',
      3: 'evaluationPlus',
      0: 'challenge',
      1: 'challengePlus',
    }
  },
  stageMap: (state, getters, rootState) => {
    return {
      0: 'challenge',
      1: 'evaluation',
      2: 'liveTrading',
    }
  },
}
